module.exports = __webpack_public_path__ + "static/media/SourceSans-Semibold.b2f0c1d0.woff";